/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseClasses/guid.ts" />
/// <reference path="../../components/common/utilities.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
///<reference path="sections/docs-and-forms.form-builder.section.ts"/>
///<reference path="docs-and-forms.models.ts"/>
///<reference path="docs-and-forms-api.service.ts"/>
///<reference path="../../components/baseClasses/dataMaintenanceContextBase.ts"/>
///<reference path="sections/docs-and-forms.main.section.ts"/>
///<reference path="../../components/logging/logging.interface.ts"/>
///<reference path="../../components/busy/busy.interface.ts"/>
///<reference path="docs-and-forms.service.ts"/>

module Meevo.Plugins.DocsAndForms {
    'use strict';
    import MeevoFileUploadService = Meevo.Components.FileUpload.MeevoFileUploadService;
    import FormTypeEnum = Meevo.Model.FormTypeEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import FormFillTypeEnum = Meevo.Plugins.DocsAndForms.FormFillTypeEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import toQPromise = Meevo.Components.Common.toQPromise;

    export class DocsAndFormsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        fileTypesEnum = Meevo.Model.FileTypes;
        docsAndFormsCreationTypeEnum = DocsAndFormsCreationTypeEnum;

        get formBuilderUrl(): string {
            return this.$sce.trustAsResourceUrl(`${this.appSettings.MEEVO_MODULES_URL}/${this.appSettings.ROUTE_NAMES.newFormBuilder}/${this.itemId}/builder`);
        }

        get formTemplatesUrl(): string {
            return this.$sce.trustAsResourceUrl(`${this.appSettings.MEEVO_MODULES_URL}/${this.appSettings.ROUTE_NAMES.newFormBuilder}/${this.itemId}/templates`);
        }

        private _sendActivateTracking = false;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    timeoutService: angular.ITimeoutService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $q: ng.IQService,
                    protected $translate: ng.translate.ITranslateService,
                    protected docsAndFormsService: IDocsAndFormsService,
                    protected dafAPIService: DocsAndFormsApiService,
                    protected $sce: ng.ISCEService,
                    protected $scope: ng.IScope,
                    private _systemTagsFactory: SystemTagsFactory) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.docsAndForms;
            this.sectionTemplatePath = 'app/plugins/docsAndForms/sectionViews/';

            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_DOCSANDFORMS_TAB_MAIN);
            this.entityType = 'docsAndForms';

            this.initializeSections();

            if (this.$scope.$$listeners[Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER] && this.$scope.$$listeners[Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER].length) {
                delete this.$scope.$$listeners[Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER];
            }

            this.$scope.$on(Meevo.Components.Common.Messages.CLOSE_FORM_DESIGNER, () => {
                (this.selectedSection as FormBuilderSection).selectedBuilder = BuilderEnum.None;
                this.reloadSelectedSection();
            });
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_DOCSANDFORMS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new MainSection(
                        0,
                        'SECTION_MAIN',
                        'main.html',
                        true,
                        false,
                        this.appSettings.API_ENDPOINTS.docsAndForms,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.DocsAndFormsMain,
                        this.busyService,
                        this.modalService,
                        this.securityKeys.MANAGEMENT_DOCSANDFORMS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.trackingService,
                        this.dafAPIService,
                        this.securityChecker,
                        this.$q)
                );
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_DOCSANDFORMS_TAB_FORMBUILDER + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new FormBuilderSection(
                        1,
                        'SECTION_FORM_BUILDER',
                        'form-builder.html',
                        false,
                        false,
                        this.appSettings.API_ENDPOINTS.docsAndForms,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.DocsAndFormsFormBuilderTab,
                        this.busyService,
                        this.modalService,
                        this.securityKeys.MANAGEMENT_DOCSANDFORMS_TAB_FORMBUILDER + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.trackingService,
                        this.$translate,
                        this.$scope
                    )
                );
            }
        }

        get showCopy(): boolean {
            return this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection && !this.selectedSection.handlesOwnCrud &&
                this.isReadonly 
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        getImageUrl(model: IDocsAndFormsModel = <IDocsAndFormsModel>{}): string {
            return MeevoFileUploadService.getImageUrl((model || <IDocsAndFormsModel>{}).meevoFile);
        }

        copy() {
            this.edit();
            const model = this.selectedSection.model as DocsAndFormsModel;
            model.isCopied = true;
            const copiedTab_TId = model.tab_TId;

            this.initializeForAdd(this.sections[0]);
            this.headerContent = "";
            this.selectedSection.model = model;
            model.id = null;
            model.displayName = null;
            model.title = null;
            model.tab_TId = null;
            model.objectState = ObjectStateEnum.Inactive;
            model.entityVersion = 0;
            model.copiedFromTab_TId = copiedTab_TId;
        }

        save() {
            return toQPromise(this.$q, async () => {
                if (this.selectedSection instanceof MainSection) {
                    const model = this.selectedSection.model as DocsAndFormsModel;

                    if (model.formFillTypeEnum === FormFillTypeEnum.OnlyOnce) {
                        model.oncePerDaySubmission = null;
                    }

                    if (this.selectedSection.isPropertyChanged('objectState') && model.objectState === ObjectStateEnum.Active && !model.suppressWarnings) {
                        await this.modalService
                            .yellowConfirm('CONFIRM_ACTIVATE_FORM', ModalTranslationModes.Translate, false, {
                                okButtonContentKey: 'LABEL_OK',
                                cancelButtonContentKey: 'LABEL_CANCEL',
                                showCancelButton: true,
                            })
                            .then(() => {
                                this._sendActivateTracking = true;
                            })
                            .catch(() => {
                                this.selectedSection.model.objectState = Meevo.Model.ObjectStateEnum.Inactive;
                            });
                    }

                    if (model.id && model.fillTypeChanged) {

                        const from = model.initialFormFillTypeEnum;
                        const to = model.formFillTypeEnum;
                        const appointmentForms = [FormFillTypeEnum.OnlyOnce, FormFillTypeEnum.EveryTime];

                        const isOtherToAppointment = appointmentForms.indexOf(from) === -1 && appointmentForms.indexOf(to) !== -1;
                        const isAppointmentToOther = appointmentForms.indexOf(from) !== -1 && appointmentForms.indexOf(to) === -1;
                        const isOtherToOther = appointmentForms.indexOf(from) === -1 && appointmentForms.indexOf(to) === -1;

                        if (model.templateHTML && (isOtherToAppointment || isAppointmentToOther || isOtherToOther)) {
                            return this.modalService.alert(
                                this.$translate.instant('VALIDATION_FORM_FILL_TYPE_UPDATE')
                            );
                        }

                        if (model.formFillTypeEnum === FormFillTypeEnum.PaymentPlan) {
                            model.serviceList = [];
                            model.membershipList = [];
                        }
                        else if (model.formFillTypeEnum === FormFillTypeEnum.Membership) {
                            model.serviceList = [];
                        }
                        else if (model.formFillTypeEnum === FormFillTypeEnum.OnlyOnce
                            || model.formFillTypeEnum === FormFillTypeEnum.EveryTime) {
                            model.membershipList = [];
                        }

                        return super.save();
                    }
 
                    return super.save();
                } else if (this.selectedSection instanceof FormBuilderSection) {
                    const model = this.selectedSection.model as DocsAndFormsModel;

                    if (!_.isObject(this.selectedSection['formBuilderModel'])) {
                        return super.save();
                    }

                    model.isBuilt = model.hasCustomField || this._systemTagsFactory.formHasSystemTags(model);
                    if (model.hasHTML && !model.isBuilt && model.templateHTMLChanged) {
                        return this.modalService.alert('WARNING_HTML_DOESNT_CONTAINS_SYS_TAGS');
                    }

                    if (model.hasHTML && model.templateHTMLChanged && this._systemTagsFactory.hasInvalidSystemTags(model)) {
                        return this.modalService.alert('WARNING_HTML_INVALID_SYS_TAGS');
                    }

                    if (model.hasHTML && model.templateHTMLChanged) {
                        model.formCreationTypeEnum = DocsAndFormsCreationTypeEnum.CustomHtmlUpload;
                    }

                    if (model.creationTypeChanged) {
                        const msg = this.$translate.instant('MESSAGE_REPLACE_FORM', { formName: model.displayName });

                        return this.modalService.redAlertConfirm(msg)
                            .then(() => super.save());
                    }

                    return super.save();
                } else {
                    return super.save();
                }
            });
        }

        postSave(model: DocsAndFormsModel) {
            super.postSave(model);

            if (this._sendActivateTracking) {
                this._sendActivateTracking = false;
                // TODO: change noun to the correct one
                this.usageTrackingLog(Meevo.Model.VerbEnum.Activated, null, this.selectedSection.model.id as any);
            }
        }

        postCancel() {
            super.postCancel();

            if (_.isObject(this.selectedSection['formBuilderModel'])) {
                DocsAndFormsApiService
                    .getDocsAndFormsModelByIdProcess(this.dataService, <any>(<FormBuilderSection>this.selectedSection).model.id)
                    .then((model) => (<FormBuilderSection>this.selectedSection).model = model);
            }

        }

        handleWarningsConfirm(warnings: any[], customHeaderMessage: string = null): ng.IPromise<any> {
            let message: string = "";
            for (let warning of warnings) {
                if (message.length > 0) {
                    message += "<br/>";
                }
                message += this.$translate.instant(warning.message) + " ";
            }
            if (warnings.length > 1) {
                message += "<br/>"; // if there is more than one warning, put question in new line
            }
            message += this.$translate.instant("MESSAGE_DAF_WARNING_CONTINUE");

            return this.modalService.confirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate)
                .catch((response: boolean) => {
                    const model = this.selectedSection.model as DocsAndFormsModel;
                    model.objectState = ObjectStateEnum.Inactive;
                });
        }
    }
}
